<template>
  <div class="car-preview">
    <div class="row">
      <div class="column small-22 small-offset-1">

        <div class="column small-22 small-centered">
          <admin-edit :title="`${car.car_model.model_name} bearbeiten`" :url="`/pl/0/cars/${car.id}/edit`"></admin-edit>
          <img v-if="car.image" :src="car.image.url"/>
        </div>

        <h3>{{ car.car_model.model_name }}</h3>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CarPreview',

    props: {
      car: {
        type: Object,
        required: true
      }

    }
  }
</script>

<style lang="scss" scoped>
.car-preview {
}
h3 {
  font-size: rem-calc(24);
  margin-top: -20px;
}
img {
  max-height: 280px;
}
</style>



// WEBPACK FOOTER //
// src/components/CarPreview.vue